'use client';

import { ColumnsItem, Icon, IconName, IconSize, Text, TextLevels, TypographyBold, View } from '@bytel/trilogy-react-ts';

type ReasonItemProps = {
    iconName: IconName;
    title: string;
    content: string;
};
export default function ReasonItem({ iconName, title, content }: ReasonItemProps) {
    return (
        <ColumnsItem>
            <View flexable className='is-centered'>
                <Icon name={iconName} size={IconSize.LARGE} />
            </View>
            <Text
                typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                className='has-text-centered-mobile'
                level={TextLevels.ONE}
            >
                {title}
            </Text>
            <Text className='has-text-centered-mobile' level={TextLevels.TWO}>
                {content}
            </Text>
        </ColumnsItem>
    );
}
